import axios from 'axios';
import store from '@/store';
import { router } from '@/main';
const baseURL = process.env.VUE_APP_API_URL;
const getAuthHeader = (token) => {
    const devMode = store.state.user.devMode;

    if (devMode) {
        return { 'X-API-KEY': `${token}` };
    } else {
        return { Authorization: `Bearer ${token}` };
    }
};

const apiRequest = async (method, url, data = null, params = {}, skipAccountCheck = false, customHeaders = {}) => {
    if (!skipAccountCheck && store.getters['user/isInvalidLoggedInAccount']) {
        console.error('Account ID is not set or user is disabled');
        store.dispatch('user/logout');
        if (router.currentRoute.value.path !== '/') {
            router.push({ name: 'Login', query: { logout: 'true' } });
        }
        return;
    }
    try {
        if (store.state.user.user.account_id) {
            params = { account: store.state.user.user.account_id, ...params };
        }
        return store.dispatch('user/apiCall', async (token) => {
            const config = {
                method: method,
                url: `${baseURL}/${url}`,
                headers: { ...getAuthHeader(token), ...customHeaders },
                params: params,
                data: data,
            };
            return await axios(config);
        });
    } catch (error) {
        throw error;
    }
};

const accountService = {
    updateEcommerceSettings(updateData) {
        return apiRequest('post', `accounts/${store.state.user.user.account_id}/update-ecommerce-settings`, updateData);
    },

    fetchAccount(account_id) {
        return apiRequest('get', `accounts/${account_id}`, null, null, true);
    },

    fetchAccountMembership() {
        return apiRequest(
            'get',
            `accounts/${store.state.user.user.account_id}/membership/${store.state.user.user.account_id}`,
        );
    },

    getAccountMembershipByExternalBillingId(externalBillingId) {
        const url = `accounts/${store.state.user.user.account_id}/customer-id/${externalBillingId}`;
        return apiRequest('get', `${url}`);
    },

    saveMetadata(data) {
        const reqData = {
            account_id: store.state.user.user.account_id,
            metadata: data,
        };
        return apiRequest('post', `accounts/${store.state.user.user.account_id}/metadata`, reqData);
    },

    /**
     * @param {string} membershipId
     * @param {Object} config
     * @param {boolean} config.status
     * @param {number} config.threshold
     * @param {number} config.quantity
     * @param {number|null} config.limit
     */
    changeMembershipAutoRecharge(membershipId, config) {
        const payload = {
            auto_recharge_status: config.status,
            auto_recharge_threshold: config.threshold,
            auto_recharge_quantity: config.quantity,
            auto_recharge_monthly_limit: config.limit,
        };
        return apiRequest(
            'post',
            `accounts/${store.state.user.user.account_id}/membership/${membershipId}/auto-recharge`,
            JSON.stringify(payload),
            {},
            false,
            { 'Content-Type': 'application/json' },
        );
    },
};

export default accountService;
